// Current roles and results follow the September 2026 résumé.
// Earlier milestones are retained from the original portfolio.
export const experience = [
  {
    id: 'aws', category: 'work', company: 'Amazon Web Services (AWS)', role: 'Software Engineering Intern',
    team: 'Journal Service Control Plane', period: 'Sep–Dec', year: '2026', featured: true,
    summary: "I'm building a dynamic rate limiter in Java for a Tier-0 service that handles 100M+ queries per second across S3, DynamoDB, Kinesis, and more.",
    highlights: [],
  },
  {
    id: 'atlassian', category: 'work', company: 'Atlassian', role: 'Software Engineering Intern',
    team: '3P Connector Data Ingestion', period: 'May–Aug', year: '2026', featured: true,
    summary: "I built and shipped resource attribution for Rovo AI’s connector platform, so usage across 5M+ resource calls per minute could be traced back to each connector.",
    story: {
      title: 'Where all those calls came from',
      text: 'The new telemetry traced 6M SQS calls every 15 minutes to an abandoned Asana workflow. Its feature flag had been left on for more than 14 months. Turning it off eliminated approximately $160 a day in wasted staging spend.',
    },
    highlights: [
      'I implemented the attribution layer in Kotlin across DynamoDB, SQS, Redis, and compute in production.',
      'To keep the instrumentation non-blocking, I used concurrent maps, atomics, and windowed aggregation. For size estimates, I sampled 1 in 128 payloads instead of serializing every call.',
      'A configuration lookup was taking roughly 98% of the wall time. I removed it, bringing p50 instrumentation latency down from 8ms to 1ms.',
    ],
  },
  {
    id: 'waterloo-research', category: 'research', company: 'University of Waterloo', role: 'Undergraduate Research Assistant',
    team: 'Prof. Sujaya Maiyya', period: 'Jan–Apr', year: '2026',
    summary: 'I researched oblivious vector search for secure similarity queries.',
    highlights: [
      'I built a C++ prototype of oblivious HNSW search to reduce access-pattern leakage in approximate-nearest-neighbour queries.',
      'I benchmarked oblivious search in trusted execution environments, measuring latency, memory overhead, and graph-traversal leakage across queries.',
    ],
  },
  {
    id: 'super', category: 'work', company: 'Super.com', role: 'Software Engineering Intern',
    team: 'Flights Backend', period: 'May–Aug', year: '2025', featured: true,
    summary: 'I built Go backend services for booking, payment, and refund workflows, with sub-50ms p90 service latency.',
    highlights: [
      'I designed an asynchronous refund dispute pipeline driven by webhooks, with idempotency guarantees for retries, duplicate events, and partial failures. It cut resolution turnaround time by 30%.',
      'I resolved 5+ critical production incidents and introduced debugging workflows that cut mean time to resolution by 50%.',
    ],
  },
  {
    id: 'otto', category: 'work', company: 'OTTO by Rockwell Automation', role: 'Software Developer Intern',
    team: 'Fleet Core', period: 'Jan–Apr', year: '2025', featured: true,
    summary: 'I developed multi-fleet interoperability in C++, Python, and ROS2 to help 500+ robots coordinate across fleets.',
    story: {
      title: 'Replacing the polling loop',
      text: 'Robot tracking was polling for updates. I replaced that polling with an event-driven ROS2 topic, cutting CPU usage by 20%.',
    },
    highlights: [
      'I migrated networking from CycloneDDS to Zenoh. Benchmarks and a production-ready proof of concept confirmed 25% lower latency and 30% higher throughput.',
    ],
  },
  {
    id: 'vector-research', category: 'research', company: 'University of Waterloo & Vector Institute', role: 'Undergraduate Research Assistant',
    team: 'Prof. Xi He', period: 'Sep–Dec', year: '2024',
    summary: 'I used Python to implement and evaluate membership inference attacks on diffusion-generated synthetic tabular datasets.',
    highlights: [],
  },
  {
    id: 'ford', category: 'work', company: 'Ford', role: 'Platform Software Developer Intern',
    team: 'Vision Compute Service', period: 'May–Aug', year: '2024',
    summary: 'I deployed a real-time Vision Compute Service in C++ with OpenVX and OpenCV for embedded hardware.',
    highlights: [
      'I sped up sensor data processing and optimized multithreaded workloads to improve performance.',
      'I integrated Gcov into Jenkins CI pipelines, making 80% functional test coverage visible and unblocking QA workflows.',
      'With Valgrind, I tracked down and fixed critical memory defects, eliminating leaks and stabilizing production firmware.',
    ],
  },
  {
    id: 'watai', category: 'research', company: 'Wat.AI', role: 'Core Design Team Member',
    team: 'Energy Modelling', period: 'Winter', year: '2024',
    summary: 'As part of the Energy Modelling Project, I explored household energy consumption with Python and Jupyter and built a linear regression model with scikit-learn.',
    highlights: [],
  },
  {
    id: 'publicis', category: 'work', company: 'Publicis Sapient', role: 'Software Engineering Intern',
    team: 'Backend Development', period: 'Spring', year: '2023',
    summary: 'During my first co-op term, I built REST APIs with Go and JavaScript for an employee management feature serving 300+ users.',
    highlights: [
      'I worked on backend microservice architectures and used Docker to make development workflows simpler.',
      'I integrated GraphQL APIs with Hasura and used SonarQube, Git, and Bitbucket to maintain code quality.',
    ],
  },
  {
    id: 'waterloo-education', category: 'education', company: 'University of Waterloo', role: 'Started Bachelor of Computer Science',
    team: 'Co-op · Artificial Intelligence specialization', period: 'Sep', year: '2022',
    summary: "I moved to Canada to study Computer Science and received the President’s Scholarship of Distinction. I expect to graduate in April 2027, and my GPA is 4.0.",
    highlights: ['My coursework includes Algorithms, Operating Systems, Concurrency, Distributed Systems, Machine Learning, and Computer Security.'],
  },
  {
    id: 'ib', category: 'education', company: 'Shiv Nadar School, Gurgaon', role: 'Graduated with an IB Diploma',
    period: 'July', year: '2022',
    summary: 'I completed the IB Diploma Programme in India with a merit scholarship.', highlights: [],
  },
  {
    id: 'olevels', category: 'education', company: 'Swiss Cottage Secondary School', role: "Completed Cambridge O Levels",
    period: 'Jan', year: '2020',
    summary: 'I grew up in Singapore and completed my GCE Cambridge O Level examinations before moving to India.', highlights: [],
  },
];
